import { FC } from 'react';
import { Image } from '@chakra-ui/react';

import NotificationExample from './assets/NotificationExample@2x.png';
import { NotificationWrapper } from './styles';

const AppPreviewNotification: FC = () => (
  <NotificationWrapper>
    <Image src={NotificationExample} />
  </NotificationWrapper>
);

export default AppPreviewNotification;
